"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _SubMenu = require("./SubMenu.styles");

var SubMenu = function SubMenu(_ref) {
  var className = _ref.className,
      children = _ref.children,
      open = _ref.open;
  return (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
    css: _SubMenu.styles.base,
    className: className,
    initial: open ? 'open' : 'collapsed',
    animate: open ? 'open' : 'collapsed',
    variants: {
      open: {
        height: 'auto'
      },
      collapsed: {
        height: 0
      }
    },
    transition: {
      duration: 0.35
    },
    children: children
  });
};

SubMenu.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,
  open: _propTypes.bool
};
SubMenu.defaultProps = {
  className: undefined,
  children: undefined,
  open: false
};
var _default = SubMenu;
exports["default"] = _default;
//# sourceMappingURL=SubMenu.js.map